// Menus and popovers inside the screen (Josh 10-02: "Some menus even go outside of the screen area"). A window draws
// its menus for the headset, placed in points beside the button that opened them; on a screen the window may be
// narrower than that, or near an edge. On a phone core/screen.css opens every menu as a sheet from the bottom; on a
// tablet or a desktop (Snap) each one, as it appears, is moved back inside the screen less its safe areas and a
// margin, made narrower when it is wider than the screen, and given a scroll when it is taller.
//
// One seam: `screenMenus(world)` — once, from core/render-dom.js; it watches the world's stage.
const POPUPS = '.menu, .scs-pop, .sheet, .alert, [role="menu"], [role="listbox"]'
const MARGIN = 8

function safeArea() {
  const p = document.createElement('div')
  p.style.cssText = 'position:fixed;visibility:hidden;pointer-events:none;padding:env(safe-area-inset-top,0px) env(safe-area-inset-right,0px) env(safe-area-inset-bottom,0px) env(safe-area-inset-left,0px)'
  document.body.appendChild(p)
  const s = getComputedStyle(p), out = { t: parseFloat(s.paddingTop) || 0, r: parseFloat(s.paddingRight) || 0, b: parseFloat(s.paddingBottom) || 0, l: parseFloat(s.paddingLeft) || 0 }
  p.remove()
  return out
}

/// One popup back inside the screen (the band the bars leave, when it is in a window).
function clamp(el, band) {
  if (getComputedStyle(el).position === 'fixed') return   // a phone's sheet (core/screen.css) is placed already
  const safe = safeArea()
  const top = Math.max(safe.t, band.top) + MARGIN, bottom = Math.min(innerHeight - safe.b, innerHeight - band.bottom) - MARGIN
  const left = safe.l + MARGIN, right = innerWidth - safe.r - MARGIN
  let r = el.getBoundingClientRect()
  if (!r.width || !r.height) return
  if (r.width > right - left) { el.style.maxWidth = (right - left) + 'px'; el.style.minWidth = '0'; el.style.whiteSpace = 'normal'; r = el.getBoundingClientRect() }
  if (r.height > bottom - top) { el.style.maxHeight = (bottom - top) + 'px'; el.style.overflowY = 'auto'; r = el.getBoundingClientRect() }
  const dx = r.left < left ? left - r.left : r.right > right ? right - r.right : 0
  const dy = r.top < top ? top - r.top : r.bottom > bottom ? bottom - r.bottom : 0
  if (!dx && !dy) return
  // moved as the window placed it: from its own left / top, whichever sides it was given
  const cs = getComputedStyle(el)
  el.style.left = (parseFloat(cs.left) || 0) + dx + 'px'; el.style.right = 'auto'
  el.style.top = (parseFloat(cs.top) || 0) + dy + 'px'; el.style.bottom = 'auto'
  el.style.marginLeft = cs.marginLeft; el.style.marginTop = cs.marginTop
}

export function screenMenus(world) {
  const stage = world.stage
  if (!stage || stage.__menus) return
  stage.__menus = true
  let queued = false
  const pass = () => {
    queued = false
    if (world.suspended || (world.mode !== 'snap' && !world.flatZoom)) return   // Look's arc is 3D: its own size
    const band = world.band()
    for (const el of stage.querySelectorAll(POPUPS)) {
      if (el.closest('.far') || el.__clamped === el.outerHTML.length) continue
      clamp(el, band)
      el.__clamped = el.outerHTML.length
    }
  }
  new MutationObserver(() => { if (!queued) { queued = true; requestAnimationFrame(pass) } }).observe(stage, { childList: true, subtree: true })
  addEventListener('resize', () => { for (const el of stage.querySelectorAll(POPUPS)) el.__clamped = 0; pass() })
}
